import React from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

import {
  EuiSpacer,
  EuiButton,
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem,
} from "@elastic/eui";

export default function WebUIArticles() {
  return (
    <React.Fragment>
      <EuiFlexItem>
        <EuiFlexGroup gutterSize="l" direction="row">
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/Web_User_Interface/1440p_Serie/Netzwerk/IP_Konfiguration/">
                  <StaticImage
                    src="../../../../images/Search/WebUI_1440p_SearchThumb_Network_IP_Configuration.webp"
                    alt="INSTAR UltraHD Serien (2K+ 1440p & 4K 2160p) Web User Interface Netzwerk Menu"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                  />
                </Link>
              }
              title="IP Konfiguration"
              description="Ändern Sie die IP-Adresse, das Gateway und den DNS-Server Ihrer Kamera - alle diese Einstellungen werden normalerweise vom Installationsassistenten eingerichtet und müssen nicht geändert werden..."
              footer={
                <EuiFlexGroup justifyContent="flexEnd">
                  <Link to="/Web_User_Interface/1440p_Serie/Netzwerk/IP_Konfiguration/">
                    <EuiFlexItem grow={false}>
                      <EuiButton size="s" fill>
                        Lesen
                      </EuiButton>
                      <EuiSpacer size="s" />
                    </EuiFlexItem>
                  </Link>
                </EuiFlexGroup>
              }
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/Web_User_Interface/1440p_Serie/Netzwerk/ONVIF/">
                  <StaticImage
                    src="../../../../images/Search/WebUI_1440p_SearchThumb_Network_ONVIF.webp"
                    alt="INSTAR UltraHD Serien (2K+ 1440p & 4K 2160p) Web User Interface Netzwerk Menu"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                  />
                </Link>
              }
              title="ONVIF Dienst"
              description="Die Überwachungsindustrie hat ein offenes Standardprotokoll namens ONVIF geschaffen, das es Kameras ermöglicht, untereinander und mit Netzwerkaufzeichnungsgeräten zu kommunizieren..."
              footer={
                <EuiFlexGroup justifyContent="flexEnd">
                  <Link to="/Web_User_Interface/1440p_Serie/Netzwerk/ONVIF/">
                    <EuiFlexItem grow={false}>
                      <EuiButton size="s" fill>
                        Lesen
                      </EuiButton>
                      <EuiSpacer size="s" />
                    </EuiFlexItem>
                  </Link>
                </EuiFlexGroup>
              }
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/Web_User_Interface/1440p_Serie/Netzwerk/WLAN/">
                  <StaticImage
                    src="../../../../images/Search/WebUI_1440p_SearchThumb_Network_WiFi.webp"
                    alt="INSTAR UltraHD Serien (2K+ 1440p & 4K 2160p) Web User Interface Network Menu"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                  />
                </Link>
              }
              title="WLAN"
              description="Ihre WiFi-Verbindung sollte bereits per WPS oder durch den Installationsassistenten eingerichtet worden sein. Verwenden Sie den WiFi-Scanner, um Ihre Kamera mit einem anderen WiFi-Netzwerk zu verbinden..."
              footer={
                <EuiFlexGroup justifyContent="flexEnd">
                  <Link to="/Web_User_Interface/1440p_Serie/Netzwerk/WLAN/">
                    <EuiFlexItem grow={false}>
                      <EuiButton size="s" fill>
                        Lesen
                      </EuiButton>
                      <EuiSpacer size="s" />
                    </EuiFlexItem>
                  </Link>
                </EuiFlexGroup>
              }
            />
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>

      <EuiSpacer />

      <EuiFlexItem>
        <EuiFlexGroup gutterSize="l" direction="row">
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/Web_User_Interface/1440p_Serie/Netzwerk/Fernzugriff/">
                  <StaticImage
                    src="../../../../images/Search/WebUI_1440p_SearchThumb_Network_Remote_Access.webp"
                    alt="INSTAR UltraHD Serien (2K+ 1440p & 4K 2160p) Web User Interface Network Menu"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                  />
                </Link>
              }
              title="Fernzugriff"
              description="Sie haben zwei Möglichkeiten, über das Internet auf Ihre Kamera zuzugreifen - der einfache Weg heißt. Der einzige Weg, um vollständigen Zugriff auf alle Funktionen Ihrer Kamera zu erhalten, heißt DDNS..."
              footer={
                <EuiFlexGroup justifyContent="flexEnd">
                  <Link to="/Web_User_Interface/1440p_Serie/Netzwerk/Fernzugriff/">
                    <EuiFlexItem grow={false}>
                      <EuiButton size="s" fill>
                        Lesen
                      </EuiButton>
                      <EuiSpacer size="s" />
                    </EuiFlexItem>
                  </Link>
                </EuiFlexGroup>
              }
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/Web_User_Interface/1440p_Serie/Netzwerk/SSL_Zertifikat/">
                  <StaticImage
                    src="../../../../images/Search/WebUI_1440p_SearchThumb_Network_IP_Configuration.webp"
                    alt="INSTAR UltraHD Serien (2K+ 1440p & 4K 2160p) Web User Interface Network Menu"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                  />
                </Link>
              }
              title="SSL Zertifikat"
              description="Unsere Kamera verwendet ein gültiges CA-SSL-Zertifikat, mit dem Sie über Ihre persönliche DDNS-Adresse verschlüsselt auf die SSL-Web-Oberfläche zugreifen können. Wenn Sie ein eigenes SSL-Zertifikat benötigen, können Sie dieses hier auf die Kamera hochladen."
              footer={
                <EuiFlexGroup justifyContent="flexEnd">
                  <Link to="/Web_User_Interface/1440p_Serie/Netzwerk/SSL_Zertifikat/">
                    <EuiFlexItem grow={false}>
                      <EuiButton size="s" fill>
                        Lesen
                      </EuiButton>
                      <EuiSpacer size="s" />
                    </EuiFlexItem>
                  </Link>
                </EuiFlexGroup>
              }
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/Web_User_Interface/1440p_Serie/Netzwerk/CA_Zertifikat/">
                  <StaticImage
                    src="../../../../images/Search/WebUI_1440p_SearchThumb_Network_IP_Configuration.webp"
                    alt="INSTAR UltraHD Serien (2K+ 1440p & 4K 2160p) Web User Interface Network Menu"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                  />
                </Link>
              }
              title="CA Zertifikat"
              description="Unsere Kamera verwendet ein gültiges CA-SSL-Zertifikat, mit dem Sie über Ihre persönliche DDNS-Adresse verschlüsselt auf die SSL-Web-Oberfläche zugreifen können. Wenn Sie ein eigenes SSL-Zertifikat benötigen, können Sie dieses hier auf die Kamera hochladen."
              footer={
                <EuiFlexGroup justifyContent="flexEnd">
                  <Link to="/Web_User_Interface/1440p_Serie/Netzwerk/CA_Zertifikat/">
                    <EuiFlexItem grow={false}>
                      <EuiButton size="s" fill>
                        Lesen
                      </EuiButton>
                      <EuiSpacer size="s" />
                    </EuiFlexItem>
                  </Link>
                </EuiFlexGroup>
              }
            />
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>

      <EuiSpacer />

      <EuiFlexItem>
        <EuiFlexGroup gutterSize="l" direction="row">
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/Web_User_Interface/1440p_Serie/Netzwerk/RTSP/">
                  <StaticImage
                    src="../../../../images/Search/WebUI_1440p_SearchThumb_Network_IP_Configuration.webp"
                    alt="INSTAR UltraHD Serien (2K+ 1440p & 4K 2160p) Web User Interface Network Menu"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                  />
                </Link>
              }
              title="RTSP"
              description="Hier können Sie die Einstellungen für den RTSP-Videostream vornehmen. Bitte beachten Sie, dass das ONVIF-Protokoll den RTSP-Stream für die Videodarstellung benötigt..."
              footer={
                <EuiFlexGroup justifyContent="flexEnd">
                  <Link to="/Web_User_Interface/1440p_Serie/Netzwerk/RTSP/">
                    <EuiFlexItem grow={false}>
                      <EuiButton size="s" fill>
                        Lesen
                      </EuiButton>
                      <EuiSpacer size="s" />
                    </EuiFlexItem>
                  </Link>
                </EuiFlexGroup>
              }
            />
          </EuiFlexItem>
          <EuiFlexItem></EuiFlexItem>
          <EuiFlexItem></EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>
    </React.Fragment>
  );
}
